import React, { useRef, useState } from 'react';
import Select from 'ps-components/ReactSelect/ReactSelect';
import { gql, useMutation } from '@apollo/client'
import { useDispatch } from 'react-redux';
import { actions as groupActions } from '../../reducers/modules/group/group';
import { CustomDropdownIndicator } from './CustomDropdownIndicator';
import { useAppState } from '../../hooks/redux';
import ToolTip from 'ps-components/ToolTip/ToolTip';

import './Select.scss';

const MAX_LENGTH = 30;
export const getGroup = gql`
  query groups {
    groups {
      id
      name
    }
    group {
      id
      name
    }
  }
`;

const setGroup = gql`
  mutation setGroup($group: GroupInput!) {
    setGroup(group: $group) {
      id
      name
    }
  }
`;

const GroupSelect = () => {
  const dispatch = useDispatch()
  const [setGroupMutation] = useMutation(setGroup)
  const { groups, session: { group } } = useAppState()

  const [tooltipVisible, setTooltipVisible] = useState<boolean>(false)
  const ref = useRef()

  const changeGroup = (selectedGroup: typeof group) => {
    setGroupMutation({
      variables: {
        group: { id: selectedGroup.id, name: selectedGroup.name }
      },
      optimisticResponse: {
        __typename: 'Mutation',
        setGroup: { __typename: 'Group', ...selectedGroup }
      },
    })
      .then(() => {
        groupActions.setGroupId(dispatch, selectedGroup.id)
      })
      .catch(console.error)
  }

  if (!groups || !group) {
    return null;
  }

  const hasOneGroup = groups && groups.length === 1

  return (
    <div
      className="group--bordered"
      onMouseEnter={() => setTooltipVisible(true)}
      onMouseLeave={() => setTooltipVisible(false)}
      onClick={() => setTooltipVisible(false)}
    >
      <div className={group.name.length > MAX_LENGTH ? 'select tooltip__present' : 'select'}>
        <Select
          ref={ref}
          options={hasOneGroup ? [] : groups}
          getOptionValue={(option: typeof group) => option.id}
          getOptionLabel={(option: typeof group) => option.name}
          components={{ DropdownIndicator: hasOneGroup ? null : CustomDropdownIndicator }}
          clearable={false}
          value={group}
          className="react-select-container"
          classNamePrefix="react-select"
          onChange={changeGroup}
          instanceId="Group-select"
          isDisabled={hasOneGroup}
        />
      </div>
      <ToolTip show={tooltipVisible && group.name.length > MAX_LENGTH} text={group.name} />
    </div>
  );
}

export default GroupSelect
